import React from "react";
import { useNotifications, polarityOf } from "../../context/NotificationContext";

/**
 * Small colored dot for one specific record (an order, enquiry, etc.) —
 * green for positive unread events (new order, quote received), red for
 * negative (cancelled, issue raised, rejected). Looks up the already
 * polled notification list client-side, so it never fires an extra
 * request per row, and clears the moment that notification is actually
 * marked read (opening the record's detail page) — never just from the
 * list/menu being visited.
 */
export function UnreadDot({ entityId, testid, className = "" }) {
  const { list } = useNotifications();
  if (!entityId) return null;
  const unread = list.filter((n) => n.entity_id === entityId && !n.read);
  if (unread.length === 0) return null;
  const negative = unread.some((n) => polarityOf(n.type) === "negative");
  return (
    <span
      data-testid={testid || `unread-dot-${entityId}`}
      className={`inline-block w-2.5 h-2.5 rounded-full ${negative ? "bg-red-500" : "bg-emerald-500"} ring-2 ring-white shrink-0 ${className}`}
      aria-label={negative ? "Unread — needs attention" : "Unread"}
    />
  );
}
